// src/main.tsx
import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import App from './App.js';
import { initThemeFromStorage } from './lib/theme.js';
import { initSentry } from './lib/sentry.js';
import './index.css';

initSentry();
initThemeFromStorage();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
    },
  },
});

queryClient.setQueryDefaults(['device-makes'], {
  staleTime: 1000 * 60 * 60,
  refetchInterval: false,
});
queryClient.setQueryDefaults(['repair-services'], {
  staleTime: 1000 * 60 * 5,
  refetchInterval: false,
});
queryClient.setQueryDefaults(['store-current'], {
  staleTime: 1000 * 60 * 5,
  refetchInterval: false,
});
queryClient.setQueryDefaults(['ticket'], {
  staleTime: 60_000,
  refetchInterval: false,
  refetchOnWindowFocus: true,
});
queryClient.setQueryDefaults(['ticket-counts'], {
  staleTime: 30_000,
  refetchInterval: false,
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  </React.StrictMode>,
);
